import { useMemo, useState } from "react";
import { RIP_OFF_QUESTIONS } from "@/data/ripOffQuestions";

const ADVANCE_DELAY = 320;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const TOTAL_STEPS = RIP_OFF_QUESTIONS.length + 1;
const CONTACT_STEP = RIP_OFF_QUESTIONS.length;

const ZAPIER_WEBHOOK_URL = "https://hooks.zapier.com/hooks/catch/22202060/uwfoscy/";

const ZAPIER_FIELD_BY_QUESTION_ID = {
  outcome: "claim_outcome",
  explanation: "explanation_quality",
  documents: "repeat_requests",
  scope: "scope_of_damage",
  pressure: "pressure_to_accept",
};

export function useDetectorForm() {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [contact, setContact] = useState({ firstName: "", email: "" });
  const [emailError, setEmailError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const isContactStep = step === CONTACT_STEP;
  const progress = useMemo(() => Math.round(((step + 1) / TOTAL_STEPS) * 100), [step]);

  const selectAnswer = (questionId, option) => {
    setAnswers((prev) => ({ ...prev, [questionId]: option }));
    window.setTimeout(() => {
      setStep((prev) => Math.min(prev + 1, CONTACT_STEP));
    }, ADVANCE_DELAY);
  };

  const goBack = () => setStep((prev) => Math.max(prev - 1, 0));

  const updateContact = (field, value) => {
    setContact((prev) => ({ ...prev, [field]: value }));
    if (field === "email" && emailError) setEmailError("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!EMAIL_PATTERN.test(contact.email.trim())) {
      setEmailError("Enter a valid email address");
      return;
    }

    const payload = new URLSearchParams();
    RIP_OFF_QUESTIONS.forEach((q) => {
      payload.append(ZAPIER_FIELD_BY_QUESTION_ID[q.id], answers[q.id] ?? "");
    });
    payload.append("first_name", contact.firstName.trim());
    payload.append("email", contact.email.trim());

    fetch(ZAPIER_WEBHOOK_URL, {
      method: "POST",
      body: payload,
    }).catch((error) => {
      console.error("Rip-Off Detector: failed to reach Zapier webhook", error);
    });

    setSubmitted(true);
  };

  const reset = () => {
    setStep(0);
    setAnswers({});
    setContact({ firstName: "", email: "" });
    setEmailError("");
    setSubmitted(false);
  };

  return {
    step,
    totalSteps: TOTAL_STEPS,
    isContactStep,
    progress,
    answers,
    contact,
    emailError,
    submitted,
    selectAnswer,
    goBack,
    updateContact,
    handleSubmit,
    reset,
  };
}
